import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { BuyerPayQuery, BuyerPayVo, BuyerPayResultQuery, The139504798 } from './type';

/**
 * 订单支付
  POST /api/order/buyer/pay
  接口ID：250505995
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-250505995
 */
export const postBuyerPay = (data: BuyerPayQuery): AxiosPromise<BuyerPayVo> => {
  return request({
    url: '/api/order/buyer/pay',
    method: 'post',
    data
  });
};

/**
 * 订单支付结果查询
  GET /api/order/buyer/pay/result
  接口ID：250506006
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-250506006
 */
export const getBuyerPay = (params: BuyerPayResultQuery): AxiosPromise<The139504798> => {
  return request({
    url: '/api/order/buyer/pay/result',
    method: 'get',
    params
  });
};
